/** Display currency for the whole app (balances, deposits, orders). */
export const CURRENCY = 'EUR';
export const CURRENCY_SYMBOL = '€';

export function formatMoney(amount, { decimals = 2 } = {}) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return `${CURRENCY_SYMBOL}0.${'0'.repeat(decimals)}`;
  return `${CURRENCY_SYMBOL}${n.toFixed(decimals)}`;
}
